export default __webpack_public_path__ + "static/media/line-h-01.84a91394.png";